<template>
  <div class="head_logo">
    <div class="page-head-background-logo"></div>
  </div>
</template>

<script>
export default {
  name: "Head"
}
</script>

<style>
.head_logo {
  padding: 24px 0 0 16px;
}
</style>
